var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0209 30C20.9923 30 18.9636 27.8955 18.9636 25.9702C18.9636 23.8657 22.183 21 24.0794 19.2537H5.86549C2.51378 19.2537 1.41125 18.7612 0.61742 17.5075C0.220507 16.9254 0 16.0746 0 15C0 12.8507 0.837927 11.7313 2.24917 11.1493C2.9548 10.8806 4.18964 10.7463 5.86549 10.7463H24.0794L21.9184 8.64179C20.7277 7.47761 19.9338 6.58209 19.5369 5.91045C19.14 5.23881 18.9636 4.61194 18.9636 4.02985C18.9636 2.14926 20.9482 0 23.0209 0C24.2117 0 25.4906 0.671644 27.2988 2.46269L40 15L27.5634 27.2687C25.4465 29.3284 24.2558 30 23.0209 30Z",
    fill: "#D9D4CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightgrey);
export default __webpack_public_path__ + "static/media/rightgrey.10753ce3fc66afeb6f7557031824990b.svg";
export { ForwardRef as ReactComponent };